import { augmentIncomingMedia } from './campaign'

export const generativeCreativeField = Object.freeze({
    headlines: 'headlines',
    bodies: 'bodies',
})

export function parseSetupProcess(data) {
    return {
        ...data,
        creatives: (data.creatives ?? []).map(x => ({
            ...x,
            media: augmentIncomingMedia(x.media),
        })),
        empty: false,
    }
}
